module.exports = __webpack_public_path__ + "static/media/fly0052.25d514ac.webp";